import { useState } from "react";
import { Link, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../hooks/useTheme";

export function RootLayout() {
  const { t, i18n } = useTranslation();
  const { theme, toggleTheme } = useTheme();
  const language = i18n.language.toUpperCase() === "RO" ? "RO" : "EN";
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="page">
      <header className="site-header">
        <div className="brand">
          <Link to="/" className="brand-link">
            PESLAR.COM
          </Link>
        </div>
        <button
          type="button"
          className="burger-button"
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span />
          <span />
          <span />
        </button>
        <nav className={`nav-links ${menuOpen ? "nav-open" : ""}`}>
          <Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>
            {t("nav.home")}
          </Link>
          <Link to="/tools" className="nav-link" onClick={() => setMenuOpen(false)}>
            {t("nav.allTools")}
          </Link>
          <div className="language-toggle language-toggle-mobile">
            <span className="language-label">{t("nav.language")}</span>
            <button
              type="button"
              className="language-button"
              onClick={() => i18n.changeLanguage(language === "EN" ? "ro" : "en")}
            >
              {language}
            </button>
          </div>
          <div className="theme-toggle theme-toggle-mobile">
            <button
              type="button"
              className="theme-button"
              onClick={toggleTheme}
              aria-label={t("nav.theme")}
              title={t("nav.theme")}
            >
              {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
            </button>
          </div>
        </nav>
        <div className="header-controls">
          <div className="theme-toggle theme-toggle-desktop">
            <button
              type="button"
              className="theme-button"
              onClick={toggleTheme}
              aria-label={t("nav.theme")}
              title={t("nav.theme")}
            >
              {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
            </button>
          </div>
          <div className="language-toggle language-toggle-desktop">
            <span className="language-label">{t("nav.language")}</span>
            <button
              type="button"
              className="language-button"
              onClick={() =>
                i18n.changeLanguage(language === "EN" ? "ro" : "en")
              }
            >
              {language}
            </button>
          </div>
        </div>
      </header>
      <Outlet />
      <footer className="site-footer">
        <div className="footer-brand">
          <span className="brand-text">PESLAR.COM</span>
          <div className="footer-links">
            <Link to="/" className="footer-link">
              {t("footer.home")}
            </Link>
            <Link to="/tools" className="footer-link">
              {t("footer.tools")}
            </Link>
          </div>
        </div>
        <div className="footer-copy">
          {t("footer.copyright", { year: new Date().getFullYear() })}
        </div>
      </footer>
    </div>
  );
}
